import { useCallback, MouseEvent } from 'react';
import { EventPanelFormType } from '@mark43/cad-api';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { useSubmitEventForm } from '../common/hooks/use-submit-event-form';
import { cssVar, HStack, useToast, Button } from '@cad-arc';
import { ROOT_PATH } from '../router/constants';
import { FrPageFooter } from '../fr-page-layout/fr-page-footer';
import { FormCancelButton } from '../forms/integrated-form-components/form-cancel-button';
import { useNavigate } from 'react-router-dom';
import { FormSaveButton } from '../forms/integrated-form-components/form-save-button';
import { useAddDrugsToForm, useAddFirearmToForm, useAddOtherItemsToForm } from './hooks';
import { createApiErrorHandler } from '@m43/core';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';

export function FrAddEventPropertyFooter() {
    const navigate = useNavigate();
    const { isSubmitting, form } = useIntegratedForm<EventPanelFormType>();
    const submitEventForm = useSubmitEventForm();
    const addFirearmToForm = useAddFirearmToForm();
    const addDrugsToForm = useAddDrugsToForm();
    const addOtherItemToForm = useAddOtherItemsToForm();
    const toast = useToast();
    const onCancel = useCallback(() => {
        form.reset();
        navigate(ROOT_PATH);
    }, [navigate, form]);
    const saveEvent = (clickEvent: MouseEvent<HTMLButtonElement>) => {
        submitEventForm(
            clickEvent,
            () => {
                form.reset();
                navigate(ROOT_PATH, {
                    state: {
                        previousLocationPathname: location.pathname,
                    },
                });
            },
            () =>
                createApiErrorHandler(() => {
                    toast({
                        status: 'error',
                        description: errorOccurredWhile('saving involved property items to event'),
                    });
                })
        );
    };

    return (
        <FrPageFooter>
            <HStack
                margin={0}
                padding={cssVar('arc.space.2')}
                alignItems="center"
                justifyContent="space-between"
                width="100%"
            >
                <FormCancelButton onClick={onCancel} />
                <HStack margin={0} padding={0} alignItems="center">
                    <Button
                        leadingVisual="Add"
                        isDisabled={isSubmitting}
                        onClick={() => addFirearmToForm('firearms')}
                    >
                        Add Firearm
                    </Button>
                    <Button
                        leadingVisual="Add"
                        isDisabled={isSubmitting}
                        onClick={() => addDrugsToForm('drugs')}
                    >
                        Add Drugs
                    </Button>
                    <Button
                        leadingVisual="Add"
                        isDisabled={isSubmitting}
                        onClick={() => addOtherItemToForm('otherItems')}
                    >
                        Add Other
                    </Button>
                    <FormSaveButton onClick={saveEvent} />
                </HStack>
            </HStack>
        </FrPageFooter>
    );
}
